import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import FilterBar from './filterBar';
import TotalEngagementInfo from './totalEngagementInfo';
import TotalEngagement from './totalEngagement';
import PhysicianEngagement from './physicianEngagement';
import DistrictBreakdown from './districtBreakdown';
import OverallImpactAnalysis from './overallImpactAnalysis';
import SearchUsingFilter from './searchUsingFilter';
import NPITable from './npiTable';
import { getTotalEngagement, getTotalEngagementDigitalEngagementChart, getProviderPage } from '../../../redux/thunks/engagementThunks';
import { REGENERON_COMPANY_ID } from '../../../constants';
import { actions } from '../../../redux/reducers/totalEngagementReducer';
import HospitalBreakdown from './hospitalBreakdown';
import PowerBi from './PowerBi';
import { getCompanyConfigurationByTag } from '../../../redux/thunks/companyThunks';

const showPowerBi = [161,66,64];

function TotalPhysicianEngagement() {
    const dispatch = useDispatch();
    const { company } = useSelector((state) => state.company);
    const { startDateRange, endDateRange } = useSelector((state) => state.filter);
    const { currentPage, pageSize, searchTerm } = useSelector((state) => state.totalEngagement);
    const { companyConfig } = useSelector(state => state.adminSettings);
    const { value } = companyConfig;
    const hospitalBreakDownCompanies = [190,191,192,233,64];
    const hideEngagamentChannel =[]; //[64,140];
    useEffect(() => {
        if (company.id) {
            dispatch(getCompanyConfigurationByTag({ companyId: company.id }));
        }
    }, [company.id]);
    const isConfigReady = companyConfig && Object.keys(companyConfig).length > 0;

    // Same two-effect shape as the digital tab. lastPageKey records the
    // page/size/search combination already on screen; skipNextTable makes the
    // table effect swallow exactly one run, because resetToInitialState has not
    // propagated when that effect fires in the same commit and currentPage is
    // still the OLD page.
    const lastPageKey = useRef(null);
    const skipNextTable = useRef(false);

    useEffect(() => {
        if (company.id || isConfigReady) {
            dispatch(actions.resetToInitialState());
            skipNextTable.current = true;
            lastPageKey.current = [1, pageSize, ''].join('|');
            dispatch(getTotalEngagement({
                companyId: company.id, startRange: startDateRange, endRange: endDateRange,
                page: 1,
                pageSize
                //isUnified: value?.toLowerCase() === 'true' || false 
            }));
            if(company.id === REGENERON_COMPANY_ID){
                dispatch(getTotalEngagementDigitalEngagementChart({
                    companyId: company.id, startRange: startDateRange, endRange: endDateRange 
                }));
            }
        }
    }, [company, startDateRange, endDateRange,isConfigReady]);

    // Table-only refetch: paging and search hit the light provider-page
    // endpoint, so the counters, charts and district breakdown above are not
    // rebuilt every time somebody turns a page.
    useEffect(() => {
        if (!(company.id || isConfigReady)) return;
        if (skipNextTable.current) {
            skipNextTable.current = false;
            return;
        }
        const pageKey = [currentPage, pageSize, searchTerm || ''].join('|');
        if (lastPageKey.current === pageKey) return;
        lastPageKey.current = pageKey;
        dispatch(getProviderPage({
            companyId: company.id,
            type: 'total',
            startRange: startDateRange,
            endRange: endDateRange,
            page: currentPage,
            pageSize,
            search: searchTerm,
        }));
    }, [company.id, startDateRange, endDateRange, currentPage, pageSize, searchTerm, isConfigReady]);


    return (
        <>
            <FilterBar />
            <Grid container spacing={2}>
                {/* Total Physician Engagement Info*/}
                <Grid item xs={12}>
                    <TotalEngagementInfo />
                </Grid>
                {/* Total Physician Engagement */}
                <Grid item xs={12}>
                    <TotalEngagement />
                </Grid>
                {/* Physician Engagement by Channels */}
                {
                    !hideEngagamentChannel.includes(company.id) ? null :
                    
                        <Grid item xs={12}>
                            <PhysicianEngagement />
                        </Grid>
                }
                {/* District Breakdown of Field Physician Engagement */}
                <Grid item xs={12}>
                    <DistrictBreakdown />
                </Grid>
                {hospitalBreakDownCompanies.includes(company.id) ?
                    <Grid item xs={12}>
                        <HospitalBreakdown/>
                    </Grid>: null
                } 
                {/* Overall Impact Analysis */}
                {company.id === REGENERON_COMPANY_ID ? <Grid item xs={12}>
                    <OverallImpactAnalysis />
                </Grid> : null}
                {/* PowerBi */}
                {
                    showPowerBi.includes(company.id) &&
                    <Grid item className='mt-3 mb-3' xs={12}>
                        <PowerBi/>
                    </Grid>
                }
                
                {/* Filters and Search */}
                <Grid item xs={12}>
                    <SearchUsingFilter />
                </Grid>
                {/* List of Npi */}
                <Grid item xs={12} sx={{ minWidth: 0 }}>
                    <NPITable />
                </Grid>
            </Grid>
        </>
    );
}

export default TotalPhysicianEngagement;